// extracted by mini-css-extract-plugin
export default {"skeleton":"y2VMkm"};